<template>
  <div class="custom-ui-grouper-wrapper" :style="{ justifyContent: justify }">
    <slot />
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    justify?:
      | 'flex-start'
      | 'flex-end'
      | 'center'
      | 'space-between'
      | 'space-around'
      | 'space-evenly'
  }>()

  const justify = props.justify ?? 'space-between'
</script>

<style scoped>
  .custom-ui-grouper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
</style>
